"use strict";
exports.__esModule = true;
var values = ['DAILY', 'WEEKLY', 'MONTHLY'];
